import axios from 'axios';
import { API_URL, URL_LOGIN } from '../constants/http.constants';
import { clearAuth, getRefreshToken, setTokens } from '../utils/auth';

// One refresh at a time: concurrent 401s share a single request, so only one of
// them rotates the token and the others cannot replay an already-rotated one.
let inFlight = null;

export const forceLogout = () => {
  clearAuth();
  window.location.href = URL_LOGIN;
};

// Deliberately uses a bare axios rather than `client`, so the refresh call can
// never recurse back through the 401 interceptor that triggered it.
export const refreshTokens = () => {
  if (inFlight) return inFlight;

  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    forceLogout();
    return Promise.reject(new Error('No refresh token stored'));
  }

  inFlight = axios
    .put(`${API_URL}/v2/auth/token`, { refresh_token: refreshToken })
    .then(({ data }) => {
      setTokens(data.token, data.refresh_token);
      return data.token;
    })
    .catch((err) => {
      // A response means the API rejected the session (invalid, expired or
      // burned). No response means the network failed — the session is still
      // good, so leave it alone and let the caller retry later.
      if (err.response) forceLogout();
      throw err;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};

// Another tab (v1 or v2 — same origin, same storage) logging out must not leave
// this one holding a dead session.
window.addEventListener('storage', (event) => {
  if (event.key === 'authorization' && !event.newValue) forceLogout();
});
